import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Heading(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_1947_14)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M0 1a1 1 0 011-1h22a1 1 0 110 2H13v21a1 1 0 11-2 0V2H1a1 1 0 01-1-1z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1947_14"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Heading;